import React, { useEffect, useRef, useState } from "react";
import { dateFormator, mapTableRows } from "../../../../utils";
import {
  Button,
  DualIcon,
  TableAdv,
  CopyToClipboard,
  SmartTooltip,
} from "../../../../components";
import { useDispatch, useSelector } from "react-redux";
import {
  formatPhoneNumberLength,
  formatWords2,
} from "../../../../utils/stringUtils";
import { usePagination } from "../../../../hooks";
import { getAllApplicantsDataStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import {
  CreateListModal,
  MailMergeModal,
} from "../Modals/MonsterModals/MonsterModals";
import ApplicantsDetailsDrawer from "../../Applicants/Applicant/Modal/ApplicantsDetailsDrawer";
import AddNoteModal from "../../ConfirmedStart/Confirmed/modals/AddNoteModal";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { fetchAllNotes } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { convertFromUTC } from "../../../../utils/dateUtils";
import AiCallModel from "../Modals/AiCallModel";
import {
  getAllIntegrationAccess,
  getAllIntegrations,
} from "../../../../redux/slices/setting/settingApi";

const getJobBoardsName = {
  1: "Internal DB",
  2: "Career Builder",
  3: "Monster",
};

const whatsappIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="14"
    height="14"
    preserveAspectRatio="xMidYMid meet"
    role="img"
    aria-label="WhatsApp"
  >
    <title>WhatsApp</title>

    <path
      fill="#25D366"
      d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 .02 5.35.02 12c0 2.11.55 4.08 1.6 5.83L0 24l6.42-1.68A11.94 11.94 0 0 0 12 24c6.63 0 12-5.35 12-12 0-3.2-1.25-6.2-3.48-8.32z"
    />

    <path
      fill="#FFFFFF"
      d="M17.56 14.01c-.3-.15-1.76-.86-2.03-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.95 1.15-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.48-.9-.8-1.51-1.78-1.69-2.08-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.48.1-.2.05-.37-.03-.52-.08-.15-.67-1.6-.92-2.19-.24-.57-.48-.49-.66-.5l-.56-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.48 1.06 2.88 1.21 3.08c.15.2 2.09 3.2 5.07 4.48 2.98 1.29 2.98.86 3.52.81.54-.05 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.41-.08-.13-.27-.2-.57-.35z"
    />
  </svg>
);

const IntegratedInternalDb = ({
  iDBQuery,
  onIDBQueryChange,
  showResumeButton,
  keywords,
  source = 1,
}) => {
  const [mailMergeModalOpen, setMailMergeModalOpen] = useState(false);
  const [createListModal, setCreateListModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const {
    totalApplicantsData: totalApplicants = [],
    totalApplicantsCount,
    totalRecords,
  } = useSelector((state) => state.internalDbES);
  const dispatch = useDispatch();
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [selectedApplicantId, setSelectedApplicantId] = useState(null);
  const [noteModal, setNotesModal] = useState(false);
  const [hoveredNotes, setHoveredNotes] = useState([]);
  const [isAiCallModalOpen, setIsAiCallModalOpen] = useState(false);
  const [hasAiCallAccess, setHasAiCallAccess] = useState(false);

  const firstRender = useRef(true);
  const { loginUserUiid } = useLoginUser();
  //console.log(selectedApplicantId)
  // Pagination Helpers
  const { page, limit, setPage, handleLimitChange } = usePagination(
    iDBQuery?.payload?.lim,
    (_newPage, newLimit) => {},
    iDBQuery?.payload?.page,
  );

  let filterData =
    Array.isArray(selected) && selected.length > 0
      ? (totalApplicants || []).filter((item) => selected.includes(item?.uiid))
      : [];

  const handleSelectionChange = (ids) => {
    setSelected(ids);
  };

  const filteredApplicantData = (totalApplicants || [])?.find(
    (c) => String(c?.uiid) === String(selectedApplicantId),
  );
  const sendData = {
    addedBy: { uiid: loginUserUiid },
    candidateId: { uiid: filteredApplicantData?.uiid },
  };

  const getHoveredNotes = async (notes) => {
    setHoveredNotes([]);

    try {
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: 2,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
    }
  };

  const columns = [
    // {
    //   key: "actions",
    //   label: "",
    //   columnMenu: false,
    //   width: "min-w-[100px]! max-w-[250px]!",
    //   render: (row) => (
    //     <div className="flex items-center">
    //       {row?.notes?.length > 0&&(
    //       <div onMouseEnter={() => row?.notes?.length > 0 ? getHoveredNotes(row?.notes) : {}} onMouseLeave={() => setHoveredNotes([])}>
    //         {row?.notes?.length > 0 &&
    //         <DualIcon
    //           size="sm"
    //           badgeIconColor={row?.notes?.length > 0 ? "bg-success" : "bg-dark"}
    //           onClick={() => {
    //             setSelectedApplicantId(row?.id);
    //             setNotesModal(true);
    //           }}
    //           tooltipDescription={
    //             Array.isArray(hoveredNotes) && hoveredNotes?.length > 0 ? (
    //               <div className="flex flex-col gap-2">
    //                 {hoveredNotes.map((hoveredNote, i) => (
    //                   <p key={i}>"{hoveredNote?.note || ""}" by {formatWords2(hoveredNote?.addedBy?.firstName) || ""} on {dateFormator(convertFromUTC(hoveredNote?.addedOn), "datetime-ampm") || ""}</p>
    //                 ))}
    //               </div>
    //             ) : (
    //               "Add note"
    //             )
    //           }
    //           tooltipDelay={500}
    //           showTooltip={true}
    //         />
    // }
    //       </div>
    //       )}

    //       <SmartTooltip
    //         description={`Migrated by ${formatWords2(row?.createdBy ?? "-")
    //           } on ${dateFormator(row?.addedOn ?? "-")}`}
    //         noicon
    //       >
    //         <Button
    //           type="icon"
    //           size="sm"
    //           variant="text"
    //           icon="save"
    //           color="black"
    //         />
    //       </SmartTooltip>
    //       <Button
    //         color="black"
    //         type="icon"
    //         variant="text"
    //         icon={"visibility"}
    //         onClick={() => {
    //           setSelectedApplicantId(row?.id);
    //           setDetailsDrawer(true);
    //         }}
    //         size="sm"
    //       />
    //     </div>
    //   ),
    // },
    {
      key: "actions",
      label: "",
      columnMenu: false,
      width: "min-w-[100px]! max-w-[250px]!",
      render: (row) => {
        const notes = Array.isArray(row?.notes) ? row.notes : [];
        const hasNotes = notes.length > 0;
        return (
          <div className="flex items-center">
            {hasNotes && (
              <div
                onMouseEnter={() => getHoveredNotes(notes)}
                onMouseLeave={() => setHoveredNotes([])}
              >
                <DualIcon
                  size="sm"
                  badgeIconColor={hasNotes ? "bg-success" : "bg-dark"}
                  onClick={() => {
                    setSelectedApplicantId(row?.id);
                    setNotesModal(true);
                  }}
                  tooltipDescription={
                    hoveredNotes?.length > 0 ? (
                      <div className="flex flex-col gap-2">
                        {hoveredNotes.map((note, i) => (
                          <p key={i}>
                            "{note?.note || ""}" by{" "}
                            {formatWords2(note?.addedBy?.firstName) || ""} on{" "}
                            {dateFormator(
                              convertFromUTC(note?.addedOn),
                              "datetime-ampm",
                            ) || ""}
                          </p>
                        ))}
                      </div>
                    ) : (
                      "Add note"
                    )
                  }
                  tooltipDelay={500}
                  showTooltip
                />
              </div>
            )}
            <SmartTooltip
              description={`Migrated by ${formatWords2(
                row?.createdBy ?? "-",
              )} on ${dateFormator(row?.addedOn ?? "-")}`}
              noicon
            >
              <Button
                type="icon"
                size="sm"
                variant="text"
                icon="save"
                color="black"
              />
            </SmartTooltip>
            <Button
              color="black"
              type="icon"
              variant="text"
              icon="visibility"
              size="sm"
              onClick={() => {
                setSelectedApplicantId(row?.id);
                setDetailsDrawer(true);
              }}
            />
          </div>
        );
      },
    },
    {
      key: "id",
      label: "ID",
      columnMenu: false,
      width: "min-w-[100px]! max-w-[120px]!",
    },
    {
      key: "name",
      label: "Name",
      columnMenu: false,
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "location",
      label: "Location",
      columnMenu: false,
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobTitle",
      label: "Job Title",
      columnMenu: false,
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "email",
      label: "Email ID",
      columnMenu: false,
      width: "min-w-[200px]! max-w-[350px]!",
      render: (row) => {
        const { email } = row;
        return email ? (
          <div className={"flex items-center gap-0.5"}>
            <CopyToClipboard
              tooltipPosition="right"
              content={email}
              title={email}
            />
            {email}
          </div>
        ) : (
          ""
        );
      },
    },
    {
      key: "contact",
      label: "Contact Number",
      columnMenu: false,
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <div className="flex items-center">
          <SmartTooltip description={"Phone"} noicon>
            <Button
              type="icon"
              variant="text"
              color="black"
              size="sm"
              icon={"phone_in_talk"}
            />
          </SmartTooltip>
          {row.contact}
          <SmartTooltip description={"text"} noicon>
            <Button
              type="icon"
              variant="text"
              color="black"
              icon={"chat"}
              size="sm"
            />
          </SmartTooltip>
          <SmartTooltip description={"Whatsapp"} noicon>
            <Button
              type="icon"
              variant="text"
              color="black"
              icon={whatsappIcon}
            />
          </SmartTooltip>
        </div>
      ),
    },

    {
      key: "experience",
      label: "Experience",
      columnMenu: false,
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "workAuth",
      label: "Work Authorization",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    // {
    //   key: "location",
    //   label: "Location",
    // },
    {
      key: "source",
      label: "Source",
      width: "min-w-[180px]! max-w-[250px]!",
    },
    {
      key: "currentCTC",
      label: "Current CTC",
      width: "min-w-[150px]! max-w-[250px]!",
    },
    {
      key: "noticePeriod",
      label: "Notice Period",
      width: "min-w-[150px]! max-w-[250px]!",
    },
    {
      key: "createdBy",
      label: "Created By",
      width: "min-w-[150px]! max-w-[250px]!",
    },
    {
      key: "lastActive",
      label: "Last Active",
      width: "min-w-[150px]! max-w-[250px]!",
    },
  ];

  // const rows = Array.from({ length: 10 }, (_, i) => ({
  //   id: i + 1,
  //   cId: 21542,
  //   name: "Shaun Marsh",
  //   email: "marsh222@gmail.com",
  //   contact: "+1(986)5487562",
  //   jobTitle: "IT Program Manager",
  //   experience: "3 years",
  //   workAuth: "USA",
  //   location: "NC, Durham",
  //   source: "Naukri",
  //   currentCtc: "$ 3,00,000",
  //   noticePeriod: "1 Month",
  //   createdBy: "Thomas Clark",
  //   lastActive: "Fri,10 Jul 2025, 20:52 (6 days ago)",
  // }));

  const integratedInternalDBRows = Array.from(
    { length: totalRecords || 0 },
    (_, i) => ({
      id: totalApplicants[i]?.uiid,
      cId: totalApplicants[i]?.uiid,
      name: formatWords2(
        totalApplicants[i]?.firstName + " " + totalApplicants[i]?.lastName,
      ),
      location:
        (totalApplicants[i]?.location?.city || "N/A") +
        "-" +
        (totalApplicants[i]?.location?.state?.code ||
          totalApplicants[i]?.location?.state ||
          "N/A") +
        "-" +
        // (totalApplicants[i]?.location?.country?.code || totalApplicants[i]?.location?.country || "N/A"),
        (totalApplicants[i]?.location?.zipCode || "N/A"),
      jobTitle: formatWords2(totalApplicants[i]?.jobTitle),
      email:
        totalApplicants[i]?.email?.primary?.email ??
        totalApplicants[i]?.email?.primary ??
        "N/A",
      contact: formatPhoneNumberLength(
        "+1",
        totalApplicants[i]?.mobile?.primary?.number,
      ),

      experience: `${totalApplicants[i]?.exp?.year || ""}.${totalApplicants[i]?.exp?.mon || ""}`,
      workAuth: totalApplicants[i]?.workAuth || "N/A",
      source: getJobBoardsName[totalApplicants[i]?.source],
      currentCtc: totalApplicants[i]?.salaryInfo?.payRate?.currency,
      noticePeriod: "N/A",
      createdBy: formatWords2(totalApplicants[i]?.addedBy?.firstName),
      lastActive: dateFormator(totalApplicants[i]?.modifiedOn, "full"),
      addedOn: dateFormator(totalApplicants[i]?.addedOn ?? "-"),
      notes: totalApplicants[i]?.notes ?? [],
    }),
  );

  const mappedRows = mapTableRows(integratedInternalDBRows, columns);

  const filteredData = (mappedRows || []).filter((row) =>
    selected.includes(row?.id),
  );

  const handleDelete = (id) => {
    setSelected((prev) => prev.filter((s) => s !== id));
  };

  const handleCBPagination = () => {
    const updatedQuery = {
      ...iDBQuery,
      payload: {
        ...iDBQuery?.payload,
        query: { ...iDBQuery?.payload?.query },
        page: page,
        lim: limit,
      },
    };
    dispatch(
      getAllApplicantsDataStart({
        ...updatedQuery,
        onSuccess: () => {
          onIDBQueryChange(updatedQuery);
        },
      }),
    );
  };

  // Pagination Use effect
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    handleCBPagination();
  }, [page, limit]);

  const fetchIntegrations = async () => {
    const integrationsPayload = {
      coll: "Integration",
      fil: JSON.stringify({
        category: { type: "NONE", value: 6 },
        type: { type: "NONE", value: 2 },
        status: { type: "NONE", value: 1 },
      }),
      ret: "uiid name",
    };
    const getIntegrations = await getAllIntegrations(integrationsPayload);

    if (getIntegrations?.success) {
      const integrationIds = getIntegrations?.data?.data?.map(
        (val) => val.uiid,
      );
      const integrationAccessPayload = {
        coll: "IntegrationAccess",
        fil: {
          integrationId: { type: "IN", value: integrationIds },
          userId: { type: "IN", value: loginUserUiid },
          status: { type: "IN", value: 1 },
        },
      };
      const getIntAccess = await getAllIntegrationAccess(
        integrationAccessPayload,
      );
      if (getIntAccess?.success) {
        setHasAiCallAccess(true);
      }
    }
  };

  useEffect(() => {
    fetchIntegrations();
  }, []);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <TableAdv
        // key={selected.join(",")}
        columns={columns}
        rows={mappedRows}
        showCheckbox
        onSelectionChange={handleSelectionChange}
        defaultSelectedRows={selected}
        toolbarRight={{
          search: true,
          filter: false,
          fullScreen: true,
          add: [
            {
              component: (
                <div className="flex gap-3">
                  <Button
                    title="Mail Merge"
                    size="sm"
                    variant="outlined"
                    onClick={() => setMailMergeModalOpen(true)}
                  />
                  {hasAiCallAccess && (
                    <Button
                      title="Ai Call"
                      size="sm"
                      variant="outlined"
                      onClick={() => setIsAiCallModalOpen(true)}
                    />
                  )}
                  <Button
                    title="Create List"
                    size="sm"
                    onClick={() => setCreateListModal(true)}
                  />
                </div>
              ),
            },
          ],
        }}
        serverPagination={true}
        totalCount={totalApplicantsCount || 0}
        page={page}
        limit={limit}
        onPageChange={setPage}
        onLimitChange={handleLimitChange}
        onPaginationChange={setPage}
      />
      <MailMergeModal
        mailMergeModalOpen={mailMergeModalOpen}
        filteredMonsterMailMergeData={filterData}
        handleDelete={handleDelete}
        setMailMergeModalOpen={setMailMergeModalOpen}
        selectedData={selected}
        source={"integratedIDB"}
        searchQuery={iDBQuery}
        //idbData={filterData}
      />
      <CreateListModal
        SetShowCreateListModal={setCreateListModal}
        showCreateListModal={createListModal}
      />
      <ApplicantsDetailsDrawer
        isOpen={detailsDrawer}
        showResumeButton={showResumeButton}
        onClose={() => setDetailsDrawer(false)}
        applicantId={selectedApplicantId}
        keywords={keywords}
        source={source}
      />
      <AddNoteModal
      key={sendData?.candidateId?.uiid || sendData?.uiid}
        isOpen={noteModal}
        onClose={() => setNotesModal(false)}
        data={sendData}
        source={1}
      />
      <AiCallModel
        isOpen={isAiCallModalOpen}
        onClose={() => setIsAiCallModalOpen(false)}
        searchQuery={iDBQuery}
        source={1}
        selectedApplicants={filterData}
      />
    </div>
  );
};

export default IntegratedInternalDb;
